/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import { MDBContainer,  MDBRow, MDBCol,MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import './timeline.css'
import {message,Empty} from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import {withRouter,Redirect} from 'react-router-dom'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import moment from 'moment'
import Skeleton from 'react-loading-skeleton';
//import { Map, Marker, MapkitProvider } from 'react-mapkit';

class timeLine extends React.Component {
  
  state={
    posts:[],
    posts2:[],
    loading:true,
    refresh:false,
    page:1,
    pages:1,
    filterType:{},
    value:'',
    count:0,
    type:null,
    search:null,
    owner:this.props.location.state?this.props.location.state.owner:null,
    modal:false,
    modelType:'COMMENT',
    commentPage:1,
    commentPages:1,
    likePage:1,
    likePages:1,
    likes:[],
    comments:[],
  }

  constructor(props){
    super(props)
    window.scrollTo(0,0)
  }

  componentDidMount(){
    this.getPosts(1,false)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }
  

  getPosts = (page,type,search,rest) =>{
    console.log("type",type)
    console.log("search",search)
    this.setState({loading:true})
    
    let url = `${BASE_END_POINT}posts?page=${page}`;
    if(type && type !== "ALL"){
      let str = '&type='+ type
      url += str
    }
    if(search ){
      let str = '&search='+ search
      url += str
    }
    if(rest) url = `${BASE_END_POINT}posts`
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{

      console.log("posts   ",response.data)
      this.setState({
        loading:false,
        refresh:false,
        posts:response.data.data,
        page:response.data.page,
        pages:response.data.pageCount,
      })
      window.scrollTo(0, 0);
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
      this.setState({loading:false,})
    })
  }
  getComments = (id,page) => {
    axios.get(`${BASE_END_POINT}posts/${id}/getPostComments?page=${page}`,{
        headers:{
          'Authorization':`Bearer ${this.props.currentUser.token}`,
          'Accept-Language':this.props.isRTL?'ar':'en'
        }
    })
    .then(response=>{
      console.log(response.data)
      this.setState({
        comments:response.data.data,
        commentPage:response.data.page,
        commentPages:response.data.pageCount,
        loadingModel:false
      })
    })
    .catch(error=>{
      console.log("ALL comments ERROR")
      console.log(error.response)
    })
  }
  getLikes = (id,page) => {
    
    axios.get(`${BASE_END_POINT}posts/${id}/getPostLikes?page=${page}`,{
        headers:{
          'Authorization':`Bearer ${this.props.currentUser.token}`,
          'Accept-Language':this.props.isRTL?'ar':'en'
        }
    })
    .then(response=>{
      console.log(response.data)
      this.setState({
        likes:response.data.data,
        likePage:response.data.page,
        likePages:response.data.pageCount,
        loadingModel:false
      })
    })
    .catch(error=>{
      console.log("ALL likes ERROR")
      console.log(error.response)
    })
  }
  delete = (id) => {
    console.log("ID   ",id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}posts/${id}`,{
     headers: {
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
     },
    })
    .then(response=>{
      l.then(() => message.success(allStrings.done, 2.5) )
      this.getPosts(this.state.page,this.state.type,this.state.search)
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
    })
  }

  paginationButtons = () =>(
    <CardActions style={{display: 'inline-flex'}}>
        <Button 
        onClick={()=>{
          if(this.state.page!==1){
            this.getPosts(1,this.state.type,this.state.search)
            this.setState({page:1})
          }
        }}
        className="pagenation" >{allStrings.first}</Button>

        <Button 
        onClick={()=>{
         if(this.state.page>1){
            this.getPosts(this.state.page-1,this.state.type,this.state.search)
            this.setState({page:this.state.page-1})
         }
        }}
        className="pagenation">{allStrings.prev}</Button>
        
        <Pagination
        onChange={(event,page)=>{
        console.log("page   ",page)
        if(page!==this.state.page){
          this.getPosts(page,this.state.type,this.state.search)
          this.setState({page:page})
        }
        
        }} 
        defaultPage={1} page={this.state.page} count={this.state.pages} style={{color:`#117183 !important`}} />
        
        <Button 
        onClick={()=>{
          if(this.state.page<this.state.pages){
            this.getPosts(this.state.page+1,this.state.type,this.state.search)
            this.setState({page:this.state.page+1})
          }
        }}
        className="pagenation">{allStrings.next}</Button>

        <Button 
         onClick={()=>{
          if(this.state.page!==this.state.pages){
            this.getPosts(this.state.pages,this.state.type,this.state.search)
            this.setState({page:this.state.pages})
          }
        }}
        className="pagenation">{allStrings.last}</Button>

    </CardActions>
  )
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  }
  getModelData = (id,modelType) => {
    this.setState({loadingModel:true})
    if(modelType === "LIKE"){
        this.getLikes(id,1)
    }else{
        this.getComments(id,1)
    }
    
  }
  modal = () =>(
    <MDBModal isOpen={this.state.modal} toggle={this.toggle} >
      <MDBModalHeader toggle={this.toggle} >{this.state.modelType === "LIKE"?"التفاعلات":"التعليقات"}</MDBModalHeader>
        <MDBModalBody>
          <MDBContainer>
            <MDBRow>
              <MDBCol md="12">
                {this.state.modelType === "LIKE"?
                <ul>
                    {this.state.loadingModel?
                    <Skeleton height={400}/> 
                    :
                    this.state.likes.length > 0 ?
                    this.state.likes.map(val =>(
                        <li style={{flexDirection:'row-reverse'}}>
                            <img class="model-per-img" src={val.user.img} alt="بدر" />
                            <p style={{width:'100%',fontWeight:400}}>{val.user.fullname}</p>
                            <img class="model-per-react" src={val.reaction.img} alt="بدر" />
                        </li>
                    ))
                    :
                    <Empty description={allStrings.noData} style={{margin:'0rem'}}/>               
                    }
                </ul>
                :
                <div>
                    {this.state.loadingModel?
                    <Skeleton height={400}/> 
                    :
                    this.state.comments.length > 0 ?
                    this.state.comments.map(val =>(
                        <div style={{flexDirection:'row-reverse',display:'flex'}}>
                            <div class="persons-react1">
                                <img ssrc={val.user.img} class="persons-react " alt=""/>
                            </div>
                            <div class="comments-bg-white bg-white">
                                <div class="comment-info">
                                    <div class="d-flex" style={{flexDirection:'row-reverse'}}>
                                        <p class="comment-person-name">{val.user.fullname}</p>
                                    </div>
                                    <div class="d-flex mt-2 comment-time">
                                    <span>{val.commen} </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                    :
                    <Empty description={allStrings.noData} style={{margin:'0rem'}}/>               
                    }
                    
                </div>
                
                }
              </MDBCol>
            </MDBRow>
          </MDBContainer>
      </MDBModalBody>
    </MDBModal>
  );
  onChangeSelect() {
    var type = document.getElementById("type-filter").value;
    this.setState({type:type});
    this.getPosts(1,type,this.state.search)
  }
  searchFunction() {
    // Replace this with your actual search logic or actions
    var inputValue = document.getElementById('posts-search').value;
    console.log('Search input changed:', inputValue);
    this.setState({search:inputValue});
    this.getPosts(1,this.state.type,inputValue);
  }
//   map = (latitude,longitude) =>{
//     return(
//         <MapkitProvider tokenOrCallback="eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkNWNzdCQlg1NVEifQ.eyJpc3MiOiI3VjMzN1RVTUhQIiwiaWF0IjoxNzAwNDgzMjM0LCJleHAiOjE3MzIwNjA4MDB9.1--SuZK6kPCIK6phmNH-14xsH5HKkaZqBokr-K61HSs5ZmXJcn6xPVpJYXsiDvk0c4sTzeXJP8jIZ8JDO-dvpQ"
//              language="en">
//             <Map center={[latitude, longitude]}>
//             <Marker latitude={latitude} longitude={longitude} />
//             </Map>
//         </MapkitProvider>
//     )
//   }
  async getAddress(latitude, longitude) {
    console.log("country");

    const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`);
    const data = await response.json();
      console.log("country",data );
    //   console.log("state",data.address.state );
    //   console.log("town",data.address.town );
    //   console.log("display_name",data.display_name);
      return 22;
  }
  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('POSTS')) return <Redirect to='/Home' />

  return (
    <div className="timeLine">
        <div id="allitems">
            {this.modal()}
            <div class="container mb-4 " id="selecting">
                <div class="row mt-3 ">
                    <div class="col-md-6 ">
                        <div class="input-group">
                            <input type="text" onInput={() => {this.searchFunction()}} class="form-control" id="posts-search" placeholder="ابحث هنا ..."
                                style={{padding: "10px 2.25rem 10px .75rem",borderRadius: "20px",textAlign:'end',height: '45px'}}/>

                        </div>
                    </div>
                    <div class="col-md-6">
                        <select class="form-select" id="type-filter"
                            style={{border:'1px solid #CED4DA',padding: "10px 2.25rem 10px .75rem",
                            borderRadius: "20px",width:"100%",textAlign:'end'}}
                            onChange={() => {this.onChangeSelect()}}>
                            <option value="ALL">جميع المنشورات</option>
                            <option value="OCCASION">مناسبه</option>
                            <option value="GIFT">هديه</option>
                            <option value="TEXT">مقالى</option>
                            <option value="IMAGE">صوره</option>
                            <option value="VIDEO">فيديو</option>
                            <option value="LOCATION">لوكيشن</option>
                            <option value="MOVIE">فيلم</option>
                            <option value="MUSIC">موسيقي</option>
                        </select>

                    </div>
                </div>
            </div>

            <section id="notFoundMessage"> </section>
            {this.state.loading?
                <Skeleton height={400}/> 
            :
            this.state.posts.length > 0 ?
                this.state.posts.map(val =>(
                    <div>
                        {val.type === "OCCASION"&&
                        <section id="OCCASION-SECTION">
                            <div class="container container-md forth">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-lg-8 p-0">
                                        <div class="card card-three">
                                            <div class=" head-div d-flex justify-content-end" style={{flexDirection:'row-reverse'}}>
                                                <div class="dropdown">
                                                    <div class=" alarm btn btn-secondary dropdown-toggle" type="button"
                                                        data-bs-toggle="dropdown" aria-expanded="false">
                                                        <span class="material-icons">more_vert</span>
                                                    </div>
                                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                        <li><a class="dropdown-item" onClick={()=>{this.props.history.push("postInfo",{data:val}) }}>رؤية التفاصيل</a></li>
                                                        
                                                    </ul>
                                                </div>
                                                
                                            </div>
                                            <div class="d-flex justify-content-center resturant-data">
                                                <img class="card-img-new-top" src={val.occasion.img}  alt="Card cap"/>
            
                                                <div class="d-flex justify-content-between align-items-center whereIAM outer-person newgif" style={{flexDirection:'row-reverse'}}>
                                                    <div class="d-flex align-items-center gap-2" style={{flexDirection:'row-reverse'}}>
                                                        <div class="person-img" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>
                                                            <img src={val.owner.img} alt=""/>
                                                        </div>
                                                        <p class="person-name" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>{val.owner.fullname} </p>
                                                    </div>
                    
                                                    <button class="wish">
                                                        وش تحب
                                                        <i class="fa-solid fa-gift"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between comments" style={{flexDirection:'row-reverse'}}>
                                                    <div class="vission-name">
                                                        <p style={{color:'#333'}}>{val.occasion.name}<a href="#" class="birthday"> {val.owner.fullname} </a> اليوم</p>
                                                    </div>
                                                    <div class="vission-comments">
                                                        <div>
                                                            <span>
                                                                <i class="fas fa-regular fa-eye"></i>
                                                                {val.totalViews}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span class="comment-num">
                                                                <i class="fas fa-regular fa-comment"></i>
                                                                {val.commentsCount}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex flex-column justify-content-start">
                                                    <p style={{color:'#333'}}> <span class="fact">{val.end === true ?'انتهت':'لم تنتهى'} </span></p>
                                                </div>
                                                <div class="d-flex reacts" style={{flexDirection:'row-reverse',margin: "25px 0"}} >
                                                    {val.likes.map(like =>(
                                                        <div class="persons-react1">
                                                            <a onClick={()=>{this.props.history.push("userInfo",{data:like.user}) }}> <img src={like.user.img} class="persons-react" alt=""/></a>
                                                            <img class="emoji" src={like.reaction.img} alt=""/>
                                                        </div>
                                                    ))}
                                                    <div class="persons-react-count" onClick={()=>{this.toggle();this.setState({modelType:'LIKE'});this.getModelData(val.id,'LIKE')}} id="btn2" 
                                                        style={{cursor: "pointer"}}>
                                                        <span>+{val.likesCount}</span>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-center">
                                                    <span class="frist-hr"></span>
                                                </div>
                                                {val.comments.map(comment =>(
                                                    <div class="d-flex  comment-box align-items-center" style={{flexDirection:'row-reverse',marginBottom:'20px'}}>
                                                        <div class="persons-react1">
                                                            <img src={comment.user.img} class=" persons-react " alt="" onClick={()=>{this.props.history.push("userInfo",{data:comment.user}) }}/>
                
                                                        </div>
                                                        <div class="bg-white" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                            <div class="comment-info " style={{width:'100%'}}>
                                                                <div class="d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                                    <p class="comment-person-name">{comment.user.fullname} </p>
                                                                    <span class="comment-time">{moment(comment.createdAt).fromNow()} </span>
                                                                </div>
                                                                <div class="d-flex mt-2 comment-time" style={{width:"100%"}}>
                                                                    <p style={{textAlign: "right",width: "100%"}}>{comment.comment}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                {val.commentsCount > 3&&
                                                <div class="d-flex justify-content-center align-items-center mb-3 mt-4 readmore"
                                                    id="comentbtn5"  data-bs-target="#largeModal"
                                                    style={{cursor: "pointer"}}>
                                                    <span style={{fontWeight: "500"}} onClick={()=>{this.toggle();this.setState({modelType:'COMMENT'});this.getModelData(val.id,'COMMENT')}}>
                                                        اقرا المزيد<i class="fas fa-solid fa-chevron-down" style={{marginRight: "13px"}}></i>
                                                    </span>
                                                </div>
                                                }
            
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        }
                        {val.type === "LOCATION"&&
                        <section id="LOCAION-SECTION">
                            <div class="container container-md forth maparea">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-lg-8 p-0">
                                        <div class="card card-three">
                                            <div class=" head-div d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                <div class="family d-flex align-items-center gap-2" style={{flexDirection:'row-reverse'}}>
                                                    <div class="persons-react1">
                                                        <img src={val.owner.img} class=" persons-react " alt=""/>
                                                    </div>
                                                    <div class="falimy-data">
                                                        <p class="person-name">{val.owner.fullname}</p>
                                                        <div class="icons" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                            <span dir="rtl"> 
                                                                <i class="fas fa-solid fa-map" style={{margin: "0 4px"}}></i>
                                                                السعوديه
                                                            </span>
                                                            <span dir="rtl" class="contryname" > </span>
                                                            <span dir="rtl"> 
                                                                {val.privacy==="CUSTOM-GROUP"?val.privacyGroup.name:
                                                                val.privacy==="PUBLIC-REGION"?'عام بالمنطقه':
                                                                val.privacy==="PRIVATE"?'خاص':'عام'}
                                                            </span>
            
                                                        </div>
            
                                                    </div>
                                                </div>
            
                                                <div class="d-flex align-items-end flex-column">
                                                    <div class="dropdown">
                                                        <div class=" alarm btn btn-secondary dropdown-toggle" type="button"
                                                            data-bs-toggle="dropdown" aria-expanded="false">
                                                            <span class="material-icons">more_vert</span>
                                                        </div>
                                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                            <li><a class="dropdown-item" onClick={()=>{this.props.history.push("postInfo",{data:val}) }}>رؤية التفاصيل</a></li>
                                                            
            
                                                        </ul>
                                                    </div>
                                                    <div class="time">
                                                        <span> {moment(val.createdAt).fromNow()} </span>
                                                    </div>
                                                </div>
            
                                            </div>
                                            
                                            <div class="d-flex justify-content-center resturant-data">
                             
                                                <div id="map">
                                                {/* {this.map(val.location.coordinates[1],val.location.coordinates[0])} */}
                                                </div>
                                                <div class="whereIAM">
                                                    <span>{val.cityName} انا في</span><br/>
                                                    {/* {(async () => {
                                                        
                                                        let result = await this.getAddress(30.60427,32.27225)
                                                        if(result){
                                                            return (
                                                                <a class="d-flex align-items-center mapurl">
                                                                    <i class="fas fa-solid fa-map" style={{margin: "0 4px"}}></i>
                                                                    <p>
                                                                        
                                                                    <span class="regionName">{result.address.state}</span> —
                                                                        <span class="area">{result.address.town}</span>
                                                                    </p>
                                                                </a>
                                                            )
                                                        }
                                                    })()} */}
                                                    

                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between align-items-center" style={{flexDirection:'row-reverse'}}>
                                                    {/* <div>
                                                        <span><i class="fas fa-solid fa-user-large"></i> انا مع </span>
            
                                                        <span> <a href="#" class="Iam-With">فهد الدوبخ</a></span>
                                                    </div> */}
                                                    <div class="vission-comments">
                                                        <div>
                                                            <span>
                                                                <i class="fas fa-regular fa-eye"></i>
                                                                {val.totalViews}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span class="comment-num">
                                                                <i class="fas fa-regular fa-comment"></i>
                                                                {val.commentsCount}
                                                            </span>
                                                        </div>
                                                    </div>
            
                                                </div>
                                                <div class="d-flex reacts" style={{flexDirection:'row-reverse',margin: "25px 0"}} >
                                                    {val.likes.map(like =>(
                                                        <div class="persons-react1">
                                                            <a onClick={()=>{this.props.history.push("userInfo",{data:like.user}) }}> <img src={like.user.img} class="persons-react" alt=""/></a>
                                                            <img class="emoji" src={like.reaction.img} alt=""/>
                                                        </div>
                                                    ))}
                                                    <div class="persons-react-count" onClick={()=>{this.toggle();this.setState({modelType:'LIKE'});this.getModelData(val.id,'LIKE')}} id="btn2" 
                                                        style={{cursor: "pointer"}}>
                                                        <span>+{val.likesCount}</span>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-center">
                                                    <span class="frist-hr"></span>
                                                </div>
            
                                                {val.comments.map(comment =>(
                                                    <div class="d-flex  comment-box align-items-center" style={{flexDirection:'row-reverse',marginBottom:'20px'}}>
                                                        <div class="persons-react1">
                                                            <img src={comment.user.img} class=" persons-react " alt="" onClick={()=>{this.props.history.push("userInfo",{data:comment.user}) }}/>
                
                                                        </div>
                                                        <div class="bg-white" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                            <div class="comment-info " style={{width:'100%'}}>
                                                                <div class="d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                                    <p class="comment-person-name">{comment.user.fullname} </p>
                                                                    <span class="comment-time">{moment(comment.createdAt).fromNow()} </span>
                                                                </div>
                                                                <div class="d-flex mt-2 comment-time" style={{width:"100%"}}>
                                                                    <p style={{textAlign: "right",width: "100%"}}>{comment.comment}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                {val.commentsCount > 3&&
                                                <div class="d-flex justify-content-center align-items-center mb-3 mt-4 readmore"
                                                    id="comentbtn5"  data-bs-target="#largeModal"
                                                    style={{cursor: "pointer"}}>
                                                    <span style={{fontWeight: "500"}} onClick={()=>{this.toggle();this.setState({modelType:'COMMENT'});this.getModelData(val.id,'COMMENT')}}>
                                                        اقرا المزيد<i class="fas fa-solid fa-chevron-down" style={{marginRight: "13px"}}></i>
                                                    </span>
                                                </div>
                                                }
                                            </div>
            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        }
                        {val.type === "VIDEO"&&
                        <section id="VIDEO-SECTION">
                            <div class="container container-md fifth">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-lg-8 p-0">
                                        <div class="card card-three">
                                            <div class=" head-div d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                <div class="family d-flex align-items-center gap-2" style={{flexDirection:'row-reverse'}}>
                                                    <div class="persons-react1" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>
                                                        <img src={val.owner.img} class=" persons-react " alt=""/>
                                                    </div>
                                                    <div class="falimy-data">
                                                        <p class="person-name" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>{val.owner.fullname} </p>
                                                        <div class="icons" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                            <span dir="rtl"> 
                                                                <i class="fas fa-brands fa-video"style={{margin: "-2px 4px"}}></i>
                                                                فيديو
                                                            </span>
                                                            <span dir="rtl"> 
                                                                {val.privacy==="CUSTOM-GROUP"?val.privacyGroup.name:
                                                                val.privacy==="PUBLIC-REGION"?'عام بالمنطقه':
                                                                val.privacy==="PRIVATE"?'خاص':'عام'}
                                                            </span>
            
                                                        </div>
            
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-end flex-column">
                                                    <div class="dropdown">
                                                        <div class=" alarm btn btn-secondary dropdown-toggle" type="button"
                                                            data-bs-toggle="dropdown" aria-expanded="false">
                                                            <span class="material-icons">more_vert</span>
                                                        </div>
                                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                            <li><a class="dropdown-item" onClick={()=>{this.props.history.push("postInfo",{data:val}) }}>رؤية التفاصيل</a></li>
                                                            
            
                                                        </ul>
                                                    </div>
                                                    <div class="time">
                                                        <span> {moment(val.createdAt).fromNow()} </span>
                                                    </div>
                                                </div>
            
                                            </div>
                                            <div class="d-flex justify-content-center resturant-data why-us">
            
                                                <div class="video-box" style={{width: '100%'}}>
                                                    <img src={val.files[0].preview} class="img-fluid" alt="" style={{width: '100%'}}/>
                                                    <a href={val.files[0].link} class="venobox play-btn mb-4"
                                                        data-vbtype="video" data-autoplay="true"></a>
                                                </div>
            
            
                                            </div>
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between align-items-center" style={{flexDirection:'row-reverse'}}>
                                                    <div>
                                                        <span>يستحق المشاهدة</span>
                                                    </div>
                                                    <div class="vission-comments">
                                                        <div>
                                                            <span>
                                                                <i class="fas fa-regular fa-eye"></i>
                                                                {val.totalViews}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span class="comment-num">
                                                                <i class="fas fa-regular fa-comment"></i>
                                                                {val.commentsCount}
                                                            </span>
                                                        </div>
                                                    </div>
            
                                                </div>
                                                <div class="d-flex reacts" style={{flexDirection:'row-reverse',margin: "25px 0"}} >
                                                    {val.likes.map(like =>(
                                                        <div class="persons-react1">
                                                            <a onClick={()=>{this.props.history.push("userInfo",{data:like.user}) }}> <img src={like.user.img} class="persons-react" alt=""/></a>
                                                            <img class="emoji" src={like.reaction.img} alt=""/>
                                                        </div>
                                                    ))}
                                                    <div class="persons-react-count" onClick={()=>{this.toggle();this.setState({modelType:'LIKE'});this.getModelData(val.id,'LIKE')}} id="btn2" 
                                                        style={{cursor: "pointer"}}>
                                                        <span>+{val.likesCount}</span>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-center">
                                                    <span class="frist-hr"></span>
                                                </div>
            
                                                {val.comments.map(comment =>(
                                                    <div class="d-flex  comment-box align-items-center" style={{flexDirection:'row-reverse',marginBottom:'20px'}}>
                                                        <div class="persons-react1">
                                                            <img src={comment.user.img} class=" persons-react " alt="" onClick={()=>{this.props.history.push("userInfo",{data:comment.user}) }}/>
                
                                                        </div>
                                                        <div class="bg-white" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                            <div class="comment-info " style={{width:'100%'}}>
                                                                <div class="d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                                    <p class="comment-person-name">{comment.user.fullname} </p>
                                                                    <span class="comment-time">{moment(comment.createdAt).fromNow()} </span>
                                                                </div>
                                                                <div class="d-flex mt-2 comment-time" style={{width:"100%"}}>
                                                                    <p style={{textAlign: "right",width: "100%"}}>{comment.comment}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
            
                                                {val.commentsCount > 3&&
                                                <div class="d-flex justify-content-center align-items-center mb-3 mt-4 readmore"
                                                    id="comentbtn5"  data-bs-target="#largeModal"
                                                    style={{cursor: "pointer"}}>
                                                    <span style={{fontWeight: "500"}} onClick={()=>{this.toggle();this.setState({modelType:'COMMENT'});this.getModelData(val.id,'COMMENT')}}>
                                                        اقرا المزيد<i class="fas fa-solid fa-chevron-down" style={{marginRight: "13px"}}></i>
                                                    </span>
                                                </div>
                                                }
            
                                            </div>
            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        }
                        {val.type === "IMAGE"&&
                        <section id="IMAGE-SECTION">
                            <div class="container container-md eight">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-lg-8 p-0">
                                        <div class="card card-three">
                                            <div class=" head-div d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                <div class="family d-flex align-items-center gap-2" style={{flexDirection:'row-reverse'}}>
                                                    <div class="persons-react1" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>
                                                        <img src={val.owner.img} class=" persons-react " alt=""/>
                                                    </div>
                                                    <div class="falimy-data">
                                                        <p class="person-name" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>{val.owner.fullname} </p>
                                                        <div class="icons" style={{flexDirection:'row-reverse',display:'flex'}}>
            
                                                            <span dir="rtl"> 
                                                                <i class="fas fa-solid fa-image"style={{margin: "0 4px"}}></i>
                                                                صوره
                                                            </span>
                                                            <span dir="rtl"> 
                                                                {val.privacy==="CUSTOM-GROUP"?val.privacyGroup.name:
                                                                val.privacy==="PUBLIC-REGION"?'عام بالمنطقه':
                                                                val.privacy==="PRIVATE"?'خاص':'عام'}
                                                            </span>
            
                                                        </div>
            
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-end flex-column">
                                                    <div class="dropdown">
                                                        <div class=" alarm btn btn-secondary dropdown-toggle" type="button"
                                                            data-bs-toggle="dropdown" aria-expanded="false">
                                                            <span class="material-icons">more_vert</span>
                                                        </div>
                                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                            <li><a class="dropdown-item" onClick={()=>{this.props.history.push("postInfo",{data:val}) }}>رؤية التفاصيل</a></li>
                                                            
            
                                                        </ul>
                                                    </div>
                                                    <div class="time">
                                                        <span> {moment(val.createdAt).fromNow()} </span>
                                                    </div>
                                                </div>
            
                                            </div>
                                            <div class="d-flex justify-content-center resturant-data">
                                                <img class="card-img-top" src={val.files[0].preview} alt="Card cap"/>
            
                                            </div>
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between align-items-center" style={{flexDirection:'row-reverse'}}>
                                                    <div>
                                                        <span class="work">{val.content}</span>
                                                    </div>
                                                    <div class="vission-comments">
                                                        <div>
                                                            <span>
                                                                <i class="fas fa-regular fa-eye"></i>
                                                                {val.totalViews}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span class="comment-num">
                                                                <i class="fas fa-regular fa-comment"></i>
                                                                {val.commentsCount}
                                                            </span>
                                                        </div>
                                                    </div>
            
                                                </div>
                                                <div class="d-flex reacts" style={{flexDirection:'row-reverse',margin: "25px 0"}} >
                                                    {val.likes.map(like =>(
                                                        <div class="persons-react1">
                                                            <a onClick={()=>{this.props.history.push("userInfo",{data:like.user}) }}> <img src={like.user.img} class="persons-react" alt=""/></a>
                                                            <img class="emoji" src={like.reaction.img} alt=""/>
                                                        </div>
                                                    ))}
                                                    <div class="persons-react-count" onClick={()=>{this.toggle();this.setState({modelType:'LIKE'});this.getModelData(val.id,'LIKE')}} id="btn2" 
                                                        style={{cursor: "pointer"}}>
                                                        <span>+{val.likesCount}</span>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-center">
                                                    <span class="frist-hr"></span>
                                                </div>
            
                                                {val.comments.map(comment =>(
                                                    <div class="d-flex  comment-box align-items-center" style={{flexDirection:'row-reverse',marginBottom:'20px'}}>
                                                        <div class="persons-react1">
                                                            <img src={comment.user.img} class=" persons-react " alt="" onClick={()=>{this.props.history.push("userInfo",{data:comment.user}) }}/>
                
                                                        </div>
                                                        <div class="bg-white" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                            <div class="comment-info " style={{width:'100%'}}>
                                                                <div class="d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                                    <p class="comment-person-name">{comment.user.fullname} </p>
                                                                    <span class="comment-time">{moment(comment.createdAt).fromNow()} </span>
                                                                </div>
                                                                <div class="d-flex mt-2 comment-time" style={{width:"100%"}}>
                                                                    <p style={{textAlign: "right",width: "100%"}}>{comment.comment}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                {val.commentsCount > 3&&
                                                <div class="d-flex justify-content-center align-items-center mb-3 mt-4 readmore"
                                                    id="comentbtn5"  data-bs-target="#largeModal"
                                                    style={{cursor: "pointer"}}>
                                                    <span style={{fontWeight: "500"}} onClick={()=>{this.toggle();this.setState({modelType:'COMMENT'});this.getModelData(val.id,'COMMENT')}}>
                                                        اقرا المزيد<i class="fas fa-solid fa-chevron-down" style={{marginRight: "13px"}}></i>
                                                    </span>
                                                </div>
                                                }
                                            </div>
            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        }
                        {val.type === "GIFT"&&
                        <section id="GIFT-SECTION">
                            <div class="container container-md forth">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-lg-8 p-0">
                                        <div class="card card-three">
                                            <div class=" head-div d-flex justify-content-end" style={{flexDirection:'row-reverse'}}>
                                                <div class="dropdown">
                                                    <div class=" alarm btn btn-secondary dropdown-toggle" type="button"
                                                        data-bs-toggle="dropdown" aria-expanded="false">
                                                        <span class="material-icons">more_vert</span>
                                                    </div>
                                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                        <li><a class="dropdown-item" onClick={()=>{this.props.history.push("postInfo",{data:val}) }}>رؤية التفاصيل</a></li>
                                                        
            
                                                    </ul>
                                                </div>
                                            </div>
            
                                            <div class="d-flex justify-content-center resturant-data">
                                                <img class="card-img-new-top" src={val.gift.img} alt="Card cap"/>
            
                                                <div class="d-flex justify-content-between align-items-center whereIAM outer-person newgif" style={{flexDirection:'row-reverse'}}>
                                                    <div class="d-flex align-items-center gap-2" style={{flexDirection:'row-reverse'}}>
                                                        <div class="person-img" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>
                                                            <img src={val.owner.img} alt=""/>
                                                        </div>
                                                        <p class="person-name" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>{val.owner.fullname} </p>
                                                    </div>
                    
                                                    <button class="wish">
                                                        {val.gift.name}
                                                        <i class="fa-solid fa-gift"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="d-flex reacts" style={{flexDirection:'row-reverse',margin: "25px 0"}} >
                                                    {val.likes.map(like =>(
                                                        <div class="persons-react1">
                                                            <a onClick={()=>{this.props.history.push("userInfo",{data:like.user}) }}> <img src={like.user.img} class="persons-react" alt=""/></a>
                                                            <img class="emoji" src={like.reaction.img} alt=""/>
                                                        </div>
                                                    ))}
                                                    <div class="persons-react-count" onClick={()=>{this.toggle();this.setState({modelType:'LIKE'});this.getModelData(val.id,'LIKE')}} id="btn2" 
                                                        style={{cursor: "pointer"}}>
                                                        <span>+{val.likesCount}</span>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-center">
                                                    <span class="frist-hr"></span>
                                                </div>
                                                {val.comments.map(comment =>(
                                                    <div class="d-flex  comment-box align-items-center" style={{flexDirection:'row-reverse',marginBottom:'20px'}}>
                                                        <div class="persons-react1">
                                                            <img src={comment.user.img} class=" persons-react " alt="" onClick={()=>{this.props.history.push("userInfo",{data:comment.user}) }}/>
                
                                                        </div>
                                                        <div class="bg-white" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                            <div class="comment-info " style={{width:'100%'}}>
                                                                <div class="d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                                    <p class="comment-person-name">{comment.user.fullname} </p>
                                                                    <span class="comment-time">{moment(comment.createdAt).fromNow()} </span>
                                                                </div>
                                                                <div class="d-flex mt-2 comment-time" style={{width:"100%"}}>
                                                                    <p style={{textAlign: "right",width: "100%"}}>{comment.comment}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                {val.commentsCount > 3&&
                                                <div class="d-flex justify-content-center align-items-center mb-3 mt-4 readmore"
                                                    id="comentbtn5"  data-bs-target="#largeModal"
                                                    style={{cursor: "pointer"}}>
                                                    <span style={{fontWeight: "500"}} onClick={()=>{this.toggle();this.setState({modelType:'COMMENT'});this.getModelData(val.id,'COMMENT')}}>
                                                        اقرا المزيد<i class="fas fa-solid fa-chevron-down" style={{marginRight: "13px"}}></i>
                                                    </span>
                                                </div>
                                                }
            
                                            </div>
            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        }
                        {val.type === "MUSIC"&&
                        <section id="MUSIC-SECTION">
                            <div class="container container-md seven">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-lg-8 p-0">
                                        <div class="card card-three">
                                            <div class=" head-div d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                <div class="family d-flex align-items-center gap-2" style={{flexDirection:'row-reverse'}}>
                                                    <div class="persons-react1" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>
                                                        <img src={val.owner.img} class=" persons-react " alt=""/>
                                                    </div>
                                                    <div class="falimy-data">
                                                        <p class="person-name" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>{val.owner.fullname} </p>
                                                        <div class="icons" style={{flexDirection:'row-reverse',display:'flex'}}>
            
                                                            <span dir="rtl"> 
                                                                <i class="fas fa-solid fa-headphones" style={{margin: "0 4px"}}></i>
                                                                موسيقى
                                                            </span>
                                                            <span dir="rtl"> 
                                                                {val.privacy==="CUSTOM-GROUP"?val.privacyGroup.name:
                                                                val.privacy==="PUBLIC-REGION"?'عام بالمنطقه':
                                                                val.privacy==="PRIVATE"?'خاص':'عام'}
                                                            </span>
            
                                                        </div>
            
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-end flex-column">
                                                    <div class="dropdown">
                                                        <div class=" alarm btn btn-secondary dropdown-toggle" type="button"
                                                            data-bs-toggle="dropdown" aria-expanded="false">
                                                            <span class="material-icons">more_vert</span>
                                                        </div>
                                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                            <li><a class="dropdown-item" onClick={()=>{this.props.history.push("postInfo",{data:val}) }}>رؤية التفاصيل</a></li>
                                                            
            
                                                        </ul>
                                                    </div>
                                                    <div class="time">
                                                        <span> {moment(val.createdAt).fromNow()} </span>
                                                    </div>
                                                </div>
            
                                            </div>
                                            <div class="d-flex justify-content-center resturant-data">
                                                <img class="card-img-top" src={val.media.image} alt="Card cap"/>
            
                                                <div class="whereIAM">
                                                    <span>أستمع الي </span><br/>
                                                    <span> {val.media.name}</span>
            
            
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between align-items-center" style={{flexDirection:'row-reverse'}}>
                                                    <div>
                                                        <span> أحلي ما غني</span>
                                                    </div>
                                                    <div class="vission-comments">
                                                        <div>
                                                            <span>
                                                                <i class="fas fa-regular fa-eye"></i>
                                                                {val.totalViews}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span class="comment-num">
                                                                <i class="fas fa-regular fa-comment"></i>
                                                                {val.commentsCount}
                                                            </span>
                                                        </div>
                                                    </div>
            
                                                </div>
                                                <div class="d-flex reacts" style={{flexDirection:'row-reverse',margin: "25px 0"}} >
                                                    {val.likes.map(like =>(
                                                        <div class="persons-react1">
                                                            <a onClick={()=>{this.props.history.push("userInfo",{data:like.user}) }}> <img src={like.user.img} class="persons-react" alt=""/></a>
                                                            <img class="emoji" src={like.reaction.img} alt=""/>
                                                        </div>
                                                    ))}
                                                    <div class="persons-react-count" onClick={()=>{this.toggle();this.setState({modelType:'LIKE'});this.getModelData(val.id,'LIKE')}} id="btn2" 
                                                        style={{cursor: "pointer"}}>
                                                        <span>+{val.likesCount}</span>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-center">
                                                    <span class="frist-hr"></span>
                                                </div>
            
                                                {val.comments.map(comment =>(
                                                    <div class="d-flex  comment-box align-items-center" style={{flexDirection:'row-reverse',marginBottom:'20px'}}>
                                                        <div class="persons-react1">
                                                            <img src={comment.user.img} class=" persons-react " alt="" onClick={()=>{this.props.history.push("userInfo",{data:comment.user}) }}/>
                
                                                        </div>
                                                        <div class="bg-white" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                            <div class="comment-info " style={{width:'100%'}}>
                                                                <div class="d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                                    <p class="comment-person-name">{comment.user.fullname} </p>
                                                                    <span class="comment-time">{moment(comment.createdAt).fromNow()} </span>
                                                                </div>
                                                                <div class="d-flex mt-2 comment-time" style={{width:"100%"}}>
                                                                    <p style={{textAlign: "right",width: "100%"}}>{comment.comment}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                {val.commentsCount > 3&&
                                                <div class="d-flex justify-content-center align-items-center mb-3 mt-4 readmore"
                                                    id="comentbtn5"  data-bs-target="#largeModal"
                                                    style={{cursor: "pointer"}}>
                                                    <span style={{fontWeight: "500"}} onClick={()=>{this.toggle();this.setState({modelType:'COMMENT'});this.getModelData(val.id,'COMMENT')}}>
                                                        اقرا المزيد<i class="fas fa-solid fa-chevron-down" style={{marginRight: "13px"}}></i>
                                                    </span>
                                                </div>
                                                }
            
            
                                            </div>
            
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                        </section>
                        }
                        {val.type === "MOVIE"&&
                        <section id="FILM-SECTION">
                            <div class="container container-md sex">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-lg-8 p-0">
                                        <div class="card card-three">
                                            <div class=" head-div d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                <div class="family d-flex align-items-center gap-2" style={{flexDirection:'row-reverse'}}>
                                                    <div class="persons-react1" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>
                                                        <img src={val.owner.img} class=" persons-react " alt=""/>
                                                    </div>
                                                    <div class="falimy-data">
                                                        <p class="person-name" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>{val.owner.fullname} </p>
                                                        <div class="icons" style={{flexDirection:'row-reverse',display:'flex'}}>
            
                                                            <span dir="rtl"> 
                                                                <i class="fas fa-solid fa-film" style={{margin: "0 4px"}}></i> 
                                                                فيلم
                                                            </span>
                                                            <span dir="rtl"> 
                                                                {val.privacy==="CUSTOM-GROUP"?val.privacyGroup.name:
                                                                val.privacy==="PUBLIC-REGION"?'عام بالمنطقه':
                                                                val.privacy==="PRIVATE"?'خاص':'عام'}
                                                            </span>
            
                                                        </div>
            
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-end flex-column">
                                                    <div class="dropdown">
                                                        <div class=" alarm btn btn-secondary dropdown-toggle" type="button"
                                                            data-bs-toggle="dropdown" aria-expanded="false">
                                                            <span class="material-icons">more_vert</span>
                                                        </div>
                                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                            <li><a class="dropdown-item" onClick={()=>{this.props.history.push("postInfo",{data:val}) }}>رؤية التفاصيل</a></li>
                                                            
            
                                                        </ul>
                                                    </div>
                                                    <div class="time">
                                                        <span> {moment(val.createdAt).fromNow()} </span>
                                                    </div>
                                                </div>
            
                                            </div>
                                            <div class="d-flex justify-content-center resturant-data">
                                                <img class="card-img-top" src={val.media.image} alt="Card cap"/>
            
                                                <div class="whereIAM">
                                                    <span>أشاهد</span><br/>
                                                    <span>{val.media.name}</span>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between align-items-center" style={{flexDirection:'row-reverse'}}>
                                                    <div>
                                                        <span> يستحق المشاهدة 
                                                            <i class="fas fa-solid fa-star"style={{color: "#f1830d"}}></i>
                                                        </span>
                                                    </div>
                                                    <div class="vission-comments">
                                                        <div>
                                                            <span>
                                                                <i class="fas fa-regular fa-eye"></i>
                                                                {val.totalViews}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span class="comment-num">
                                                                <i class="fas fa-regular fa-comment"></i>
                                                                {val.commentsCount}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex reacts" style={{flexDirection:'row-reverse',margin: "25px 0"}} >
                                                    {val.likes.map(like =>(
                                                        <div class="persons-react1">
                                                            <a onClick={()=>{this.props.history.push("userInfo",{data:like.user}) }}> <img src={like.user.img} class="persons-react" alt=""/></a>
                                                            <img class="emoji" src={like.reaction.img} alt=""/>
                                                        </div>
                                                    ))}
                                                    <div class="persons-react-count" onClick={()=>{this.toggle();this.setState({modelType:'LIKE'});this.getModelData(val.id,'LIKE')}} id="btn2" 
                                                        style={{cursor: "pointer"}}>
                                                        <span>+{val.likesCount}</span>
                                                    </div>
                                                </div>
                                                <div class="d-flex justify-content-center">
                                                    <span class="frist-hr"></span>
                                                </div>
                                            
                                                {val.comments.map(comment =>(
                                                    <div class="d-flex  comment-box align-items-center" style={{flexDirection:'row-reverse',marginBottom:'20px'}}>
                                                        <div class="persons-react1">
                                                            <img src={comment.user.img} class=" persons-react " alt="" onClick={()=>{this.props.history.push("userInfo",{data:comment.user}) }}/>
                
                                                        </div>
                                                        <div class="bg-white" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                            <div class="comment-info " style={{width:'100%'}}>
                                                                <div class="d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                                    <p class="comment-person-name">{comment.user.fullname} </p>
                                                                    <span class="comment-time">{moment(comment.createdAt).fromNow()} </span>
                                                                </div>
                                                                <div class="d-flex mt-2 comment-time" style={{width:"100%"}}>
                                                                    <p style={{textAlign: "right",width: "100%"}}>{comment.comment}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                {val.commentsCount > 3&&
                                                <div class="d-flex justify-content-center align-items-center mb-3 mt-4 readmore"
                                                    id="comentbtn5"  data-bs-target="#largeModal"
                                                    style={{cursor: "pointer"}}>
                                                    <span style={{fontWeight: "500"}} onClick={()=>{this.toggle();this.setState({modelType:'COMMENT'});this.getModelData(val.id,'COMMENT')}}>
                                                        اقرا المزيد<i class="fas fa-solid fa-chevron-down" style={{marginRight: "13px"}}></i>
                                                    </span>
                                                </div>
                                                }
                                            </div>
            
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                        </section>
                        }
                        {val.type === "TEXT"&&
                        <section id="TEXT-SECTION">
                            <div class="container container-md ten">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-lg-8 p-0">
                                        <div class="card card-three">
                                            <div class=" head-div d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                <div class="family d-flex align-items-center gap-2" style={{flexDirection:'row-reverse'}}>
                                                    <div class="persons-react1" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>
                                                        <img src={val.owner.img} class=" persons-react " alt=""/>
                                                    </div>
                                                    <div class="falimy-data">
                                                        <p class="person-name" onClick={()=>{this.props.history.push("userInfo",{data:val.owner}) }}>{val.owner.fullname} </p>
                                                        <div class="icons" style={{flexDirection:'row-reverse',display:'flex'}}>
            
                                                            <span dir="rtl"> 
                                                                <i class="fas fa-solid fa-newspaper" style={{margin: "0 4px"}}></i>
                                                                نص
                                                            </span>
            
                                                            <span dir="rtl"> 
                                                                {val.privacy==="CUSTOM-GROUP"?val.privacyGroup.name:
                                                                val.privacy==="PUBLIC-REGION"?'عام بالمنطقه':
                                                                val.privacy==="PRIVATE"?'خاص':'عام'}
                                                            </span>
            
                                                        </div>
            
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-end flex-column">
                                                    <div class="dropdown">
                                                        <div class=" alarm btn btn-secondary dropdown-toggle" type="button"
                                                            data-bs-toggle="dropdown" aria-expanded="false">
                                                            <span class="material-icons">more_vert</span>
                                                        </div>
                                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                                            <li><a class="dropdown-item" onClick={()=>{this.props.history.push("postInfo",{data:val}) }}>رؤية التفاصيل</a></li>
                                                            
            
                                                        </ul>
                                                    </div>
                                                    <div class="time">
                                                        <span> {moment(val.createdAt).fromNow()} </span>
                                                    </div>
                                                </div>
            
                                            </div>
                                            <div class="d-flex justify-content-center resturant-data">
                                                <div class="details">
                                                    <div dangerouslySetInnerHTML={{ __html: val.content }} />
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between align-items-center" style={{flexDirection:'row-reverse'}}>
                                                    <div>
                                                    <div class="d-flex reacts" style={{flexDirection:'row-reverse',margin: "25px 0"}} >
                                                    {val.likes.map(like =>(
                                                        <div class="persons-react1">
                                                            <a onClick={()=>{this.props.history.push("userInfo",{data:like.user}) }}> <img src={like.user.img} class="persons-react" alt=""/></a>
                                                            <img class="emoji" src={like.reaction.img} alt=""/>
                                                        </div>
                                                    ))}
                                                    <div class="persons-react-count" onClick={()=>{this.toggle();this.setState({modelType:'LIKE'});this.getModelData(val.id,'LIKE')}} id="btn2" 
                                                        style={{cursor: "pointer"}}>
                                                        <span>+{val.likesCount}</span>
                                                    </div>
                                                </div>
                                                    </div>
                                                    <div class="vission-comments">
                                                        <div>
                                                            <span>
                                                                <i class="fas fa-regular fa-eye"></i>
                                                                {val.totalViews}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span class="comment-num">
                                                                <i class="fas fa-regular fa-comment"></i>
                                                                {val.commentsCount}
                                                            </span>
                                                        </div>
                                                    </div>
            
                                                </div>
            
                                                <div class="d-flex justify-content-center">
                                                    <span class="frist-hr"></span>
                                                </div>
            
            
                                                {val.comments.map(comment =>(
                                                    <div class="d-flex  comment-box align-items-center" style={{flexDirection:'row-reverse',marginBottom:'20px'}}>
                                                        <div class="persons-react1">
                                                            <img src={comment.user.img} class=" persons-react " alt="" onClick={()=>{this.props.history.push("userInfo",{data:comment.user}) }}/>
                
                                                        </div>
                                                        <div class="bg-white" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                            <div class="comment-info " style={{width:'100%'}}>
                                                                <div class="d-flex justify-content-between" style={{flexDirection:'row-reverse',display:'flex'}}>
                                                                    <p class="comment-person-name">{comment.user.fullname} </p>
                                                                    <span class="comment-time">{moment(comment.createdAt).fromNow()} </span>
                                                                </div>
                                                                <div class="d-flex mt-2 comment-time" style={{width:"100%"}}>
                                                                    <p style={{textAlign: "right",width: "100%"}}>{comment.comment}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                {val.commentsCount > 3&&
                                                <div class="d-flex justify-content-center align-items-center mb-3 mt-4 readmore"
                                                    id="comentbtn5"  data-bs-target="#largeModal"
                                                    style={{cursor: "pointer"}}>
                                                    <span style={{fontWeight: "500"}} onClick={()=>{this.toggle();this.setState({modelType:'COMMENT'});this.getModelData(val.id,'COMMENT')}}>
                                                        اقرا المزيد<i class="fas fa-solid fa-chevron-down" style={{marginRight: "13px"}}></i>
                                                    </span>
                                                </div>
                                                }
                                            </div>
            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        }
                    </div>
                                
                ))
              
            :
            <div style={{height: '200px'}}>
                <Empty description={allStrings.noData} style={{margin:'0rem'}}/>
            </div>
            }
            {this.state.posts.length > 0 &&
                <div style={{textAlign:'center',margin:'auto',marginTop:'3rem'}}>
                    {this.paginationButtons()}
                </div>
            }
        </div>
    </div> 
  )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(timeLine)
);

